import gql from 'graphql-tag';


const ConfirmLogin = gql`mutation authConfirm($code:String!, $email:String!) {
  authConfirm(email:$email, code:$code)
}
`;

export default ConfirmLogin;
